import { Action } from '@ngrx/store';


export enum AuthActionType{
    LOGIN='[auth] Login',
    LOGOUT='[auth] Logout'
}

export class AuthLoginAction implements Action{
    readonly type = AuthActionType.LOGIN;
    constructor(public payload: any) {}
}

export class AuthLogoutAction implements Action{
    readonly type = AuthActionType.LOGOUT;
    constructor(public payload: any) {}
}

export type AuthAction =  AuthLoginAction | AuthLogoutAction;